import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/musik';
const recap = ['6 volymer', '5 bonusar', '240 sidor', 'Årskurs 1–9'];
const reassurances = ['Omedelbar digital nedladdning', 'Utskrivbara PDF-filer', '7 dagars nöjdhetsgaranti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsormn3uimq">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbk9e684mx9p" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ec7ldi5irk5j">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1n0u1zlo35x">
          Din musikundervisning kan vara <em className="text-red-700" data-id="element-118" data-mp="1o67ojeh8qfbm">redo redan idag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="223w7uhvnteek">
          I stället för att leta efter aktiviteter, skapa varje övning själv och lägga söndagskvällarna
          på planering har du ett organiserat musikpaket för hela läsåret. Mer tid till det som
          verkligen betyder något:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x3s7sip4h867">
          Dina elever. Din undervisning. Ditt liv utanför skolan.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="120sbwo2ew0uo">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b39xr1e5mrh5">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b1qjthfz0sij">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fwcufie8ah1k">Engångsbetalning – ingen prenumeration.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1kvfoy8wl14va">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1pt8ynbx3gh0b" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1tu16q1u8cfv0">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3qtw06l9yjijx">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3lvkos640kzzl" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}